import { config } from 'config';

const sitecoreCdnAssetUrl = `${config.sitecoreMediaApi}/<id>.ashx`;

export const toSitecoreUrl = (id: string) => sitecoreCdnAssetUrl.replace('<id>', id);
